export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/user-products`;
}

export function Delete(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/user-products/${ID}`;
}

export function ListMembershipUserProducts(): string {
	return `/v1/accounts/self/memberships`;
}

export function QRToken(): string {
	return `/v1/accounts/self/membership-card/qr-token`;
}

export function Update(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/user-products/${ID}`;
}

export function VerifyMembership(userProductID: string, timestamp: string, signature: string): string {
	return `/v1/verify/${userProductID}/${timestamp}/${signature}`;
}

